import React from "react";
import Layout from "../../layouts/Layout";
import IconCashWorkView from "../../components/icons/icon-cash-work";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import helper from "../../utils/helper";
import apiService from "../../utils/api.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import _ from "lodash"

class CashWorkView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cashWork: [
        { id:1 , name: 'xxxxxxxxxxxxxxxxxxxxxxxx '},
        { id:2 , name: 'yyyyyyyyyyyyyyyyyyyyyyyy '},
        { id:3 , name: 'zzzzzzzzzzzzzzzzzzzzzzzz '},
      ]
    };
    this.LoadCashWorkView = this.LoadCashWorkView.bind(this)
  }

  componentDidMount() {
    this.LoadCashWorkView()
  }

  async LoadCashWorkView() {
    try {
      const qAnnouceId = this.props.searchParams.get('AnnouceId')
      const payload = { memberId: this.props?.user?.lineId?.memberId, annouceId: qAnnouceId }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CashWork.SearchAnnouceView(payload, header)
      if (resData.resultCode === "20000") {
        let data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        const annouceId = this.props.searchParams.get('annouceId')
        data = data.filter(item => item.annouceId == annouceId)
        this.setState({ cashWork: data })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  render() {
    const { cashWork } = this.state
    return (
      <Layout>
        <div className="main-header">
          {
             cashWork.map((item, index)=> {
              return <div className="main-header-text">{ item.title }</div>
             })
          }
        </div>
        <div className="main-body view2">
          <IconCashWorkView style={{ margin: "auto", textAlign: "center" }} />
          <div className="row">
            <div className="col-xs-12 ml-15">
              <ul className="detail-body">
                {
                  cashWork.map((item, index)=> {
                    return <li key={index}>{item.annouce}</li>
                  })
                }
              </ul>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

function CashWorkViewRoute(props) {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return <CashWorkView navigate={navigate} searchParams={searchParams} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(CashWorkViewRoute);
